import { createAction } from 'typesafe-actions'

import { Id, Timestamp, ResumeVehicle } from 'src/types'

import { VehiclesActionTypes, VehiclesState } from './types'

type Filters = {
  num_adults: number
  vehicles: number
  trend_origin_id: Id
  trend_destination_id: Id
  checkin_date: Timestamp
  checkout_date: Timestamp
}

export const getVehicles = createAction(
  VehiclesActionTypes.GET_VEHICLES,
  action =>
    ({
      customer_supplier_id,
      filters
    }: {
      customer_supplier_id?: Id
      filters: Filters
    }) =>
      action({ customer_supplier_id, filters })
)

export const getVehiclesSuccess = createAction(
  VehiclesActionTypes.GET_VEHICLES_SUCCESS,
  action => (list: ResumeVehicle[], message_id: string[]) =>
    action({ list, message_id })
)

export const getVehiclesFailure = createAction(
  VehiclesActionTypes.GET_VEHICLES_FAILURE,
  action => (message: string) => action({ message })
)

export const getVehiclesHistory = createAction(
  VehiclesActionTypes.GET_VEHICLES_HISTORY,
  action =>
    ({ request_id }: { request_id: Id }) =>
      action({ request_id })
)

export const getVehiclesHistorySuccess = createAction(
  VehiclesActionTypes.GET_VEHICLES_HISTORY_SUCCESS,
  action =>
    ({
      originalFullRequestVehiclesHistory
    }: Pick<VehiclesState, 'originalFullRequestVehiclesHistory'>) =>
      action({
        originalFullRequestVehiclesHistory
      })
)

export const getVehiclesHistoryFailure = createAction(
  VehiclesActionTypes.GET_VEHICLES_HISTORY_FAILURE,
  action => (message: string) => action({ message })
)

export const resetVehicles = createAction(
  VehiclesActionTypes.RESET_VEHICLES,
  action => () => action()
)
